import {all, call, put, select, takeEvery, takeLatest} from 'redux-saga/effects';
import {AppState} from 'shared/store';
import {sharedCommonActions} from '../../../library/src/common/redux/SharedCommonActions';
import {
  ContractsModel,
  DeleteContractsResponse,
  DeleteType,
} from '../../../library/src/contracts/models/ContractsModel';
import {getErrorMessage, logger} from '../../../library/src/core/services/LogService';
import pixagriContractApiService from '../services/PixagriContractApiService';
import {ContractState} from './ContractState';
import {
  DELETE_CONTRACTS,
  DeleteContractsAction,
  GET_CONTRACTS,
  GetContractsAction,
  POST_CONTRACTS,
  PostContractsAction,
  sharedContractActions,
} from './SharedContractActions';

export default function* sharedContractsSagas() {
  yield all([
    takeLatest(GET_CONTRACTS, getContractsSaga),
    takeEvery(POST_CONTRACTS, postContractsSaga),
    takeEvery(DELETE_CONTRACTS, deleteContractsSaga),
  ]);
}

function* getContractsSaga(action: GetContractsAction) {
  try {
    yield put(sharedCommonActions.fetchStart('getContractsSaga'));
    const contracts: ContractsModel[] = yield call(
      pixagriContractApiService.getContracts.bind(pixagriContractApiService),
      action.payload.campaign_year,
    );
    yield put(sharedContractActions.getContractsSuccess(contracts));
    yield put(sharedCommonActions.fetchSuccess('getContractsSaga'));
  } catch (error) {
    const message = getErrorMessage(error);
    logger.error(message, {
      error: error,
    });
    yield put(sharedCommonActions.fetchError('getContractsSaga', message));
  }
}

function* postContractsSaga(action: PostContractsAction) {
  try {
    yield put(sharedCommonActions.fetchStart('postContractsSaga'));

    const newContract: ContractsModel = yield call(
      pixagriContractApiService.postContracts.bind(pixagriContractApiService),
      action.payload,
    );

    const {data}: ContractState = yield select((state: AppState) => state.contracts);

    let contracts: ContractsModel[];

    const exists = data.some((contract) => contract.id === newContract.id);

    if (exists) {
      contracts = data.map((contract) => (contract.id === newContract.id ? newContract : contract));
    } else {
      contracts = [...data, newContract];
    }
    yield put(sharedContractActions.postContractsSuccess(contracts));
    yield put(sharedCommonActions.fetchSuccess('postContractsSaga'));
  } catch (error: any) {
    const apiMessage = error?.response?.data?.message || getErrorMessage(error);
    logger.error(apiMessage, {
      error: error,
    });
    yield put(sharedCommonActions.fetchError('postContractsSaga', apiMessage));
  }
}

function* deleteContractsSaga(action: DeleteContractsAction) {
  try {
    yield put(sharedCommonActions.fetchStart('deleteContractsSaga'));

    const deletedContract: DeleteContractsResponse = yield call(
      pixagriContractApiService.deleteContracts.bind(pixagriContractApiService),
      action.payload,
    );
    if (deletedContract.type === DeleteType.DELETE) {
      yield put(sharedContractActions.deleteContractsSuccess(deletedContract.data));
    } else if (deletedContract.type === DeleteType.CANCEL) {
      yield put(sharedContractActions.cancelContractsSuccess(deletedContract.data));
    }
    yield put(sharedCommonActions.fetchSuccess('deleteContractsSaga'));
  } catch (error) {
    const message = getErrorMessage(error);
    logger.error(message, {
      error: error,
    });
    yield put(sharedCommonActions.fetchError('deleteContractsSaga', message));
  }
}
